import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLogs } from "../context/LogContext";
import "./Consent.css"; // Include the CSS file for styling

const Consent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { addLog } = useLogs();
  // State to track if the checkbox is checked
  const [isChecked, setIsChecked] = useState(false);

  // Get the target path from navigation state, default to /verify-phone
  const nextPath = location.state?.next || "/verify-phone";

  // Function to handle checkbox change
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked); // Toggle the checkbox state
  };

  return (
    <div className="container">
      <div className="left-content">
        <h2>ByoSync – User Registration Consent & Terms</h2>
        <p>Your trusted app for secure face-based UPI payments.</p>

        <h3>Before You Begin</h3>
        <ul>
          <li>
            Please review and accept our Terms of Service and Data Consent to
            continue.
          </li>
        </ul>

        <h3>Eligibility</h3>
        <ul>
          <li>
            You confirm that you are 18 years or older and legally competent to
            use ByoSync.
          </li>
        </ul>

        <h3>What You Agree To</h3>
        <ul>
          <li>
            We collect and process your name, mobile number, UPI ID, and device
            information to enable payments.
          </li>
          <li>
            If you enable face recognition, we process your biometric data for
            verification and payment authorization.
          </li>
          <li>
            Your data is encrypted and stored in India per RBI, NPCI, and
            government policies.
          </li>
        </ul>

        <h3>Your Rights & Data Storage</h3>
        <ul>
          <li>You can access, correct, or delete your data anytime.</li>
          <li>
            You can withdraw consent anytime, but doing so will deactivate your
            account.
          </li>
          <li>
            Legally required data will be retained for 7 years before deletion
            or anonymization.
          </li>
        </ul>

        <h3>Security & Breach Notice</h3>
        <ul>
          <li>
            We use end-to-end encryption, device binding, and audit logs to
            protect your data.
          </li>
          <li>
            Any data breach will be reported per CERT-In/ RBI/NPCI guidelines.
          </li>
        </ul>

        <h3>Data Localization</h3>
        <ul>
          <li>
            All payment, KYC, and biometric data are stored and processed only
            in India.
          </li>
          <li>
            Any third-party processors are India-based and DPDP Act compliant.
          </li>
        </ul>

        <div className="consent-checkbox">
          <input
            type="checkbox"
            id="acceptConsent"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label htmlFor="acceptConsent">
            I am 18 years or older and I give explicit consent to ByoSync to
            process my biometric and KYC data as per the Terms & Conditions.
          </label>
        </div>

        <div className="buttons">
          <button className="btn" onClick={() => navigate("/")}>
            Decline
          </button>
          <button
            id="acceptBtn"
            className="btn"
            disabled={!isChecked} // Disable if not checked
            onClick={() => {
              addLog(`Accept Consent Form as per DPDP ACT`);
              sessionStorage.setItem("consentAccepted", "true");
              
              // If the next destination is /scan, grant access
              if (nextPath === "/scan") {
                sessionStorage.setItem("canAccessScan", "true");
              }
              
              navigate(nextPath);
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default Consent;
